import { Checkbox, type CheckboxProps } from '@chakra-ui/react';

export type UiCheckboxProps = CheckboxProps;

export const UiCheckbox = Checkbox;
